import type {LayerProps} from 'react-map-gl';

export const clusterLayer: LayerProps = {
  id: 'clusters',
  type: 'circle',
  source: 'vehicles',
  filter: ['has', 'point_count'],
  paint: {
    'circle-color': '#f28cb1',
    'circle-radius': ['step', ['get', 'point_count'], 15, 10, 20, 50, 25, 100, 30, 750, 40]
  }
};

export const clusterCountLayer: LayerProps = {
  id: 'cluster-count',
  type: 'symbol',
  source: 'vehicles',
  filter: ['has', 'point_count'],
  layout: {
    'text-field': '{point_count_abbreviated}',
    'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
    'text-size': 12,
    "text-allow-overlap":true
  }
};

export const unclusteredPointLayer: LayerProps = {
  id:"unclustered-point",
  type:"symbol",
  layout:{
    "icon-image": "pin",
    "icon-allow-overlap": true,
    "icon-offset": [0,.2],
    "text-field": ["get", "unitNumber"],
   "text-offset": [0, 2],
   "text-size": 10,
   "text-allow-overlap":true
  },
  paint:{ "text-halo-color": "white", "text-halo-width": 1 },
  source:"vehicles",
 filter:["!", ["has", "point_count"]]
};

export const currentLocationLayer: LayerProps = {
  id:"current-location-point",
  type:"symbol",
  layout:{
    "icon-image": "pin",
    "icon-allow-overlap": true,
    "icon-offset": [0,.2],
    "text-field": ["get", "unitNumber"],
   "text-offset": [0, 2],
   "text-size": 10,
   "text-allow-overlap":true
  },
  paint:{ "text-halo-color": "white", "text-halo-width": 1 },
  source:"vehicles",
};

export const hubLayer: LayerProps = {
  id:"hubs-layer",
  type:"symbol",
  layout:{
    "icon-image": "hub",
    "icon-allow-overlap": true,
    "icon-offset": [0,.2],
  },
  source:"hubSource",
};